import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { projectType } from "../../store/projectType/actions";
export var useProjectTypeGetAll = function (trigger, clientId) {
    var _a = useState(true), enable = _a[0], setEnable = _a[1];
    var _b = useState(1), page = _b[0], setPage = _b[1];
    var _c = useState(100), limit = _c[0], setLimit = _c[1];
    var dispatch = useDispatch();
    var _d = useSelector(function (state) {
        var _a;
        return ({
            responseProjectType: (_a = state.ProjectType.responseProjectType) === null || _a === void 0 ? void 0 : _a.data,
            errorProjectType: state.ProjectType.errorProjectType,
            loadingProjectType: state.ProjectType.loadingProjectType,
        });
    }), responseProjectType = _d.responseProjectType, errorProjectType = _d.errorProjectType, loadingProjectType = _d.loadingProjectType;
    useEffect(function () {
        if (trigger) {
            dispatch(projectType({
                clientId: clientId,
                enable: enable,
                page: page,
                limit: limit,
            }));
        }
    }, [trigger, clientId]);
    return {
        responseProjectType: responseProjectType,
        errorProjectType: errorProjectType,
        loadingProjectType: loadingProjectType,
        setEnable: setEnable,
        setPage: setPage,
        setLimit: setLimit,
    };
};
